var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    fill: "#DDF8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 58a2.999 2.999 0 1 1-6 0 2.999 2.999 0 1 1 6 0ZM77 58a2.999 2.999 0 1 1-6 0 2.999 2.999 0 1 1 6 0ZM42 58a2.999 2.999 0 1 0 6 0 2.999 2.999 0 1 0-6 0Z",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.548 72.635c7.66-6.446 9.393-15.652 5.3-24.845-2.01-4.514-6.07-8.283-11.184-8.283-1.244 0-2.445.19-3.583.531C69.189 35.364 64.036 32 57.959 32c-5.605 0-10.422 2.862-12.628 6.976a7.762 7.762 0 0 0-3.005-.603c-4.349 0-7.877 3.554-7.877 7.933 0 2.563 1.23 4.818 3.101 6.268A11.851 11.851 0 0 0 32 62.62c0 6.542 5.265 11.84 11.761 11.84.201 0 .398-.02.599-.029 1.247 5.164 6.215 9.025 12.167 9.025 0 0 6.392.683 13.683-4.839L87.229 87l-6.68-14.365Z",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalNote);
export default __webpack_public_path__ + "static/media/personal_note.39790184f5e1440ea4ec44c03335216f.svg";
export { ForwardRef as ReactComponent };